import styled from 'styled-components'

export const Container = styled.div`
  border-bottom: 1px solid var(--vo-cloud);
  width: 100%;
`

export const TabList = styled.div.attrs({ role: 'tablist' })`
  display: flex;
  gap: 0;
`

export const TabButton = styled.button.attrs({ role: 'tab' })`
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  color: ${({ $active }) => $active ? 'var(--color-brand)' : 'var(--vo-slate)'};
  font-weight: ${({ $active }) => $active ? 600 : 400};
  font-size: 14px;
  padding: 12px 24px;
  cursor: pointer;
  width: fit-content;
  transition: color 0.2s, border-color 0.2s, background 0.2s;

  &:hover {
    background: var(--vo-capri-50);
  }

  &[aria-selected="true"] {
    border-bottom-color: var(--color-brand);
  }
`
